// extracted by css-extract-rspack-plugin
export default {"measuring":"GLgCG","header":"jY94o","headerRow":"Ti_Xc","cell":"NDVrL"};